import { gql } from '@apollo/client';

import { useConferenceContentPropertiesExist_ConferenceEventFragment } from './graphql-types/useConferenceContentPropertiesExist_ConferenceEventFragment';

export function useConferenceContentPropertiesExist(
  conferenceEvent?: useConferenceContentPropertiesExist_ConferenceEventFragment
): {
  hasSessions: boolean;
  hasBooths: boolean;
  hasDescription: boolean;
  hasVisibleSpeakers: boolean;
} {
  if (!conferenceEvent) {
    return {
      hasSessions: false,
      hasBooths: false,
      hasDescription: false,
      hasVisibleSpeakers: false,
    };
  }

  const hasDescription = !!conferenceEvent.description?.blocks.find(
    (block) => !!block.text.length
  );

  const hasVisibleSpeakers = !!conferenceEvent.speakersWithSessions.filter(
    (speaker) => !speaker.isHidden
  ).length;

  return {
    hasSessions: conferenceEvent.sessions.totalCount > 0,
    hasBooths: conferenceEvent.conferenceBooths.totalCount > 0,
    hasDescription,
    hasVisibleSpeakers,
  };
}

useConferenceContentPropertiesExist.conferenceEventFragment = gql`
  fragment useConferenceContentPropertiesExist_ConferenceEventFragment on ConferenceEventV2 {
    _id
    description
    sessions(input: {}) {
      totalCount
    }
    conferenceBooths {
      totalCount
    }
    speakersWithSessions {
      speaker {
        _id
      }
      isHidden
    }
  }
`;
